import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** The camera swings behind a click-to-move walk (render/cameraFollow.ts); off = the 9yin way (turn by hand). */
    cameraFollow: boolean;
  }
}

defineSetting({
  key: 'cameraFollow',
  default: false,
  order: 351,
  menu: { group: 'visual', label: 'กล้องหมุนตามทิศเดินเมื่อคลิกเดิน' },
});
